import React, { useState, useEffect } from "react";
import { db } from "./firebase.js";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import "./AdminEventi.css"; // puoi riusare lo stesso css

export default function AdminBilancio() {
  // Stato unico per il form
  const [tipo, setTipo] = useState("spesa");
  const [form, setForm] = useState({
    dipartimento: "",
    descrizione: "",
    importo: "",
    data: ""
  });
  // Spese e ingressi
  const [spese, setSpese] = useState([]);
  const [ingressi, setIngressi] = useState([]);
  const [loadingSpese, setLoadingSpese] = useState(true);
  const [loadingIngressi, setLoadingIngressi] = useState(true);

  // Fetch spese
  const fetchSpese = async () => {
    setLoadingSpese(true);
    try {
      const snapshot = await getDocs(collection(db, "bilancio"));
      setSpese(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (err) {
      console.error("Errore fetch spese:", err);
    }
    setLoadingSpese(false);
  };
  // Fetch ingressi
  const fetchIngressi = async () => {
    setLoadingIngressi(true);
    try {
      const snapshot = await getDocs(collection(db, "ingressi"));
      setIngressi(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (err) {
      console.error("Errore fetch ingressi:", err);
    }
    setLoadingIngressi(false);
  };

  useEffect(() => {
    fetchSpese();
    fetchIngressi();
  }, []);

  // Salva nuovo movimento
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.dipartimento || !form.descrizione || !form.importo || !form.data) {
      alert("Tutti i campi sono obbligatori");
      return;
    }
    try {
      if (tipo === "spesa") {
        await addDoc(collection(db, "bilancio"), {
          dipartimento: form.dipartimento,
          descrizione: form.descrizione,
          importo: parseFloat(form.importo),
          data: form.data,
          createdAt: Date.now()
        });
        setForm({ dipartimento: "", descrizione: "", importo: "", data: "" });
        fetchSpese();
      } else {
        await addDoc(collection(db, "ingressi"), {
          dipartimento: form.dipartimento,
          descrizione: form.descrizione,
          importo: parseFloat(form.importo),
          data: form.data,
          createdAt: Date.now()
        });
        setForm({ dipartimento: "", descrizione: "", importo: "", data: "" });
        fetchIngressi();
      }
    } catch (err) {
      alert("Errore salvataggio movimento");
      console.error(err);
    }
  };

  // Elimina spesa
  const handleDeleteSpesa = async (id) => {
    if (!window.confirm("Eliminare questa spesa?")) return;
    await deleteDoc(doc(db, "bilancio", id));
    setSpese(prev => prev.filter(s => s.id !== id));
  };
  // Elimina ingresso
  const handleDeleteIngresso = async (id) => {
    if (!window.confirm("Eliminare questo ingresso?")) return;
    await deleteDoc(doc(db, "ingressi", id));
    setIngressi(prev => prev.filter(i => i.id !== id));
  };

  // UI
  return (
    <div className="admin-container">
      <h3>Gestione Bilancio</h3>

      <form className="admin-filters" onSubmit={handleSubmit} style={{marginBottom: 32}}>
        <select value={tipo} onChange={e => setTipo(e.target.value)} style={{marginRight: 8}}>
          <option value="spesa">Spesa</option>
          <option value="incasso">Incasso</option>
        </select>
        <select
          value={form.dipartimento}
          onChange={e => setForm(f => ({ ...f, dipartimento: e.target.value }))}
          required
        >
          <option value="">Seleziona dipartimento</option>
          <option value="demm">DEMM</option>
          <option value="dst">DST</option>
          <option value="ding">DING</option>
        </select>
        <input
          type="text"
          placeholder={tipo === "spesa" ? "Descrizione spesa" : "Descrizione incasso"}
          value={form.descrizione}
          onChange={e => setForm(f => ({ ...f, descrizione: e.target.value }))}
          required
        />
        <input
          type="number"
          step="0.01"
          placeholder="Importo (€)"
          value={form.importo}
          onChange={e => setForm(f => ({ ...f, importo: e.target.value }))}
          required
        />
        <input
          type="date"
          value={form.data}
          onChange={e => setForm(f => ({ ...f, data: e.target.value }))}
          required
        />
        <button className="admin-button" type="submit">
          Salva {tipo === "spesa" ? "spesa" : "incasso"}
        </button>
      </form>

      {/* Tabella ingressi */}
      <h4>Incassi</h4>
      {loadingIngressi ? (
        <p>Caricamento incassi...</p>
      ) : (
        <table className="admin-table" style={{marginBottom: 40}}>
          <thead>
            <tr>
              <th>Dipartimento</th>
              <th>Descrizione</th>
              <th>Importo (€)</th>
              <th>Data</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {ingressi.map(i => (
              <tr key={i.id}>
                <td>{i.dipartimento?.toUpperCase?.()}</td>
                <td>{i.descrizione}</td>
                <td>{i.importo?.toFixed ? i.importo.toFixed(2) : i.importo}</td>
                <td>{i.data}</td>
                <td>
                  <button className="admin-button" onClick={() => handleDeleteIngresso(i.id)}>
                    Elimina
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Tabella spese */}
      <h4>Spese</h4>
      {loadingSpese ? (
        <p>Caricamento spese...</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Dipartimento</th>
              <th>Descrizione</th>
              <th>Importo (€)</th>
              <th>Data</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {spese.map(s => (
              <tr key={s.id}>
                <td>{s.dipartimento?.toUpperCase?.()}</td>
                <td>{s.descrizione}</td>
                <td>{s.importo?.toFixed ? s.importo.toFixed(2) : s.importo}</td>
                <td>{s.data}</td>
                <td>
                  <button className="admin-button" onClick={() => handleDeleteSpesa(s.id)}>
                    Elimina
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
